export default __webpack_public_path__ + "static/media/india2019B.cbbd0bd0.jpg";